import React from 'react'
import PropTypes from 'prop-types'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import IcomoonReact from 'icomoon-react'
import iconSet from 'src/assets/icons/rebrandIconList.json'
import Colors from 'src/assets/styles/variables.module.scss'

const TypeProps = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  name: PropTypes.string,
  selected: PropTypes.bool,
  onChange: PropTypes.func
}

const Checkbox = ({ id, name, selected, onChange }) => {
  return (
    <div
      className={generalStyles.flexRow}
      style={{
        position: 'relative',
        display: 'inline-block',
        width: '22px',
        height: '22px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: selected ? Colors.evantaBlue : Colors.c06slate757575,
        backgroundColor: selected ? Colors.c01lightBase0000d3 : 'white'
      }}
    >
      <input
        type="checkbox"
        onChange={() => onChange(id, selected)}
        value={selected}
        id={id}
        style={{
          position: 'absolute',
          opacity: 0,
          width: '24px',
          height: '24px',
          borderWidth: '1px',
          borderColor: Colors.c06slate757575,
          accentColor: Colors.c01lightBase0000d3
        }}
      />
      <label htmlFor={id}>
        {selected && <IcomoonReact
          icon="Controls-Tick"
          iconSet={iconSet}
          color={'white'}
          size={12}
          style={{
            position: 'absolute',
            paddingTop: '5.5px',
            paddingLeft: '5.0px'
          }}
        />}
      </label>
      <label key={id} style={{ position: 'absolute', left: '44px', top: '1px' }} className={fontStyles.psmallboldlsin08blackgraphik15pt}>
        {name}
      </label>
    </div>
  )
}

Checkbox.propTypes = {
  ...TypeProps
}

export default Checkbox
